export default {
  data: () => ({

    chartData:   [],
    cutoff:      null,
    
    canvasForms: null,
    canvasChart: null,

    title:      null,
    timeline:   {},
    primary:    null,
    secondary:  null,
    chart:      null,
    legends:    null,
    keys:       null,
    filters:    null,
  }),





  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}